import { render, staticRenderFns } from "./autoPerson.vue?vue&type=template&id=014f6d07&scoped=true"
import script from "./autoPerson.vue?vue&type=script&lang=js"
export * from "./autoPerson.vue?vue&type=script&lang=js"
import style0 from "./autoPerson.vue?vue&type=style&index=0&id=014f6d07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014f6d07",
  null
  
)

export default component.exports